const Device = require('current-device');
let VueDevice = {};
VueDevice.install = (Vue, options) => {
	let device = () => {
		return Device
	}
	Vue.prototype.$device = device;
}

module.exports = VueDevice;